import React, { Component } from 'react';
import { Modal, Space, Table } from 'antd';
import { connect } from 'react-redux';
import { FaBan, FaPencilAlt } from 'react-icons/fa';
import utils from '../../common/utils';
import PopupEditCoins from './PopupEditCoins';
import { BsFillLightningFill } from 'react-icons/bs';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import settingActions from '../../redux/actions/setting_data';
import DisplayControl from '../DisplayControl';
import consts from '../../consts';

const { confirm } = Modal;

const PERMISSION_LINK_SCREEN_CLOSE_COIN = "/setting/coin-setting/close-coin";
const PERMISSION_LINK_SCREEN_OPEN_COIN = "/setting/coin-setting/open-coin";

const LEVEL_DEFAULT = '1';

class CoinTableComponent extends Component {
  getColumns = (limits) => {
    return [
      {
        align: 'center',
        title: 'Đồng',
        dataIndex: 'coin',
        key: 'coin',
        width: '10%',
        render: (coin, item) => {
          return <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <div style={{
              width: '50%',
              textAlign: '-webkit-right'
            }}>
              <div style={{
                backgroundImage: `url(${item.icon_image})`,
                height: '24px',
                width: '24px',
                backgroundSize: 'contain',
                marginRight: '20px',
                display: 'block',
                backgroundRepeat: 'no-repeat'
              }} alt={coin} />

            </div>
            <div style={{
              width: '50%',
              textAlign: 'left',
              fontWeight: 'bold'
            }}>{coin}</div>
          </div>;
        }
      },
      {
        align: 'center',
        title: 'Tên đầy đủ',
        dataIndex: 'name',
        key: 'name',
      },
      {
        align: 'center',
        title: 'Mạng',
        dataIndex: 'type',
        key: 'type',
      },
      {
        align: 'center',
        title: 'Phí nạp',
        dataIndex: 'depositFee',
        key: 'depositFee',
        render: () => <div>Miễn Phí</div>
      },
      {
        align: 'center',
        title: 'Phí rút',
        dataIndex: 'symbol',
        key: 'symbol',
        render: (symbol, coin) => {
          coin.fee = limits[`${symbol}:${LEVEL_DEFAULT}`]?.fee ?? 0;
          return (<div>{utils.formatCurrency(coin.fee)}</div>);
        }
      },
      {
        align: 'center',
        title: 'Địa chỉ',
        width: 300,
        dataIndex: 'contract_address',
        render: (addr) => <div className='ellipsis w-300' title={addr}>
          {addr.toLowerCase()}
        </div>
      },
      {
        align: 'center',
        title: 'Lượng rút tối thiểu',
        dataIndex: 'symbol',
        key: 'symbol',
        render: (symbol, coin) => {
          coin.minimum_withdrawal = limits[`${symbol}:${LEVEL_DEFAULT}`]?.minimum_withdrawal ?? '';
          return (<div>{utils.formatCurrency(coin.minimum_withdrawal || 0)}</div>);
        }
      },
      {
        align: 'center',
        title: 'Lối mã giao dịch',
        dataIndex: 'transaction_explorer',
        render: (path, coinSetting) => {
          return <a href={`${path}/address/${coinSetting.contract_address}`}
            target='_blank'>{`${path ? 'Thông tin địa chỉ' : ''}`}</a>;
        },
      },
      {
        align: 'center',
        title: 'Hành động',
        key: 'action',
        render: (_, item) => (
          <Space size="middle">
            {
              item.is_closed ? <DisplayControl permission_link_screen={consts.AUTH.SETTING__COIN_SETTING__OPEN_COIN__cOIN} action={consts.CONTROLS.PUT}>
                <BsFillLightningFill className="styled-icon"
                  onClick={() => this.openCoin(item.coin)} />
              </DisplayControl> :
                <DisplayControl permission_link_screen={consts.AUTH.SETTING__COIN_SETTING__CLOSE_COIN__cOIN} action={consts.CONTROLS.PUT}>
                  <FaBan className="styled-icon"
                    onClick={() => this.closeCoin(item.coin)} />
                </DisplayControl>

            }
            <FaPencilAlt className="styled-icon" onClick={() => this.showModalEdit(item)} />
          </Space>
        ),
      },
    ];
  };

  constructor(props) {
    super(props);
    this.state = {
      popupEditCoin: false,
      coin: {},
    };
  }

  showModalEdit = (coin) => {
    this.setState({
      popupEditCoin: true,
      coin
    });
  };

  closeModalEditCoin = () => {
    this.setState({ popupEditCoin: false });
  };

  changePopup = async () => {
    await this.setState({
      isVisible: true
    });
  };

  closePopup = async (isVisible) => {
    await this.setState({
      isVisible,
    });
  };

  openCoin = (coin) => {
    const openCoin = this.props.openCoin;

    confirm({
      title: `Bạn có chắc chắn muốn mở lại giao dịch đồng ${coin}?`,
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: 'Mở giao dịch đồng',
      okType: 'danger',
      cancelText: 'Hủy',
      onOk() {
        openCoin(coin);
      },
    });
  };

  closeCoin = (coin) => {
    const closeCoin = this.props.closeCoin;

    confirm({
      title: `Bạn có chắc chắn muốn đóng giao dịch đồng ${coin}?`,
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: 'Đóng giao dịch đồng',
      okType: 'danger',
      cancelText: 'Hủy',
      onOk() {
        closeCoin(coin);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  onSearchCoin = (coin) => {
    return window._.filter(this.props.selectionCoin || [], (value, index) => {
      return value.coin.includes(coin)
    })
  }

  render() {
    return (
      <div>
        <Table dataSource={!this.props.coinSearch ? this.props.selectionCoin || [] : this.onSearchCoin(this.props.coinSearch)}
          columns={this.getColumns(this.props.limits)} bordered />
        <PopupEditCoins isVisible={this.state.popupEditCoin} closePopup={this.closeModalEditCoin}
          coinSetting={this.state.coin} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  limits: state.setting.cryptoLimitWithdrawal,
  arrCoins: state.setting.arrCoins,
  selectionCoin: state.setting.selectionCoin,
});

const mapDispatchToProps = (dispatch) => ({
  closeCoin: (params) => {
    dispatch(settingActions.closeCoinAction(params));
  },
  openCoin: (params) => {
    dispatch(settingActions.openCoinAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CoinTableComponent);
